import { render, staticRenderFns } from "./portWarehouseChargesForm.vue?vue&type=template&id=4a0b4c9d&scoped=true&"
import script from "./portWarehouseChargesForm.vue?vue&type=script&lang=js&"
export * from "./portWarehouseChargesForm.vue?vue&type=script&lang=js&"
import style0 from "./portWarehouseChargesForm.vue?vue&type=style&index=0&id=4a0b4c9d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0b4c9d",
  null
  
)

export default component.exports